var map = {
	"./1.png": 21,
	"./10.png": 22,
	"./11.png": 23,
	"./12.png": 24,
	"./13.png": 25,
	"./14.png": 26,
	"./15.png": 27,
	"./16.png": 28,
	"./17.png": 29,
	"./18.png": 30,
	"./19.png": 31,
	"./2.png": 32,
	"./20.png": 33,
	"./21.png": 34,
	"./22.png": 35,
	"./23.png": 36,
	"./24.png": 37,
	"./3.png": 38,
	"./4.png": 39,
	"./5.png": 40,
	"./6.png": 41,
	"./7.png": 42,
	"./8.png": 43,
	"./9.png": 44,
	"./cover.png": 10
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;